import React from 'react';
import { Helmet } from 'react-helmet';

const DEFAULT_SITE_URL = 'https://www.myfounderdna.com';

const getSiteOrigin = () => {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return DEFAULT_SITE_URL;
};

const buildAbsoluteUrl = (origin, maybePath) => {
  if (!maybePath) return origin;
  if (maybePath.startsWith('http://') || maybePath.startsWith('https://')) return maybePath;
  if (maybePath.startsWith('/')) return `${origin}${maybePath}`;
  return `${origin}/${maybePath}`;
};

export const Seo = ({ title, description, path = '/', imagePath = '/favicon.svg' }) => {
  const origin = getSiteOrigin();
  const url = buildAbsoluteUrl(origin, path);
  const imageUrl = buildAbsoluteUrl(origin, imagePath);

  const fullTitle = title ? `${title} | FounderDNA` : 'FounderDNA';
  const metaDescription =
    description ||
    'Get your founder operating profile in minutes. Learn how you tend to lead, decide, and execute, plus a weekly plan you can apply right away.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <link rel="canonical" href={url} />
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/favicon.svg" />

      <meta name="description" content={metaDescription} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default Seo;

